"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buttonStyle = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const base_ui_components_atoms__atoms_1 = require("@motorata/base-ui.components.atoms._atoms");
const base_ui_components_atoms_icon_1 = __importDefault(require("@motorata/base-ui.components.atoms.icon"));
const base_ui_components_atoms_spinner_1 = __importDefault(require("@motorata/base-ui.components.atoms.spinner"));
const Button = (_a) => {
    var { children, type = "primary", icon, submit, onClick, loading, ariaLabel, disabled, padding, color, hoverColor, hoverBackground } = _a, rest = __rest(_a, ["children", "type", "icon", "submit", "onClick", "loading", "ariaLabel", "disabled", "padding", "color", "hoverColor", "hoverBackground"]);
    return (react_1.default.createElement(StyledButton, Object.assign({ "aria-label": ariaLabel !== null && ariaLabel !== void 0 ? ariaLabel : children, styledType: type, 
        // @ts-ignore
        type: submit ? "submit" : "button", onClick: onClick, disabled: disabled, loading: loading, padding: padding, color: color, hoverColor: hoverColor, hoverBackground: hoverBackground }, rest),
        react_1.default.createElement(base_ui_components_atoms__atoms_1.Row, { alignItems: "center", opacity: loading ? 0 : 1 },
            icon && react_1.default.createElement(base_ui_components_atoms_icon_1.default, { icon: icon }),
            children),
        loading && (react_1.default.createElement(base_ui_components_atoms__atoms_1.Absolute, { width: "100%", height: "100%", left: "0", top: "0", display: "flex", alignItems: "center", justifyContent: "center" },
            react_1.default.createElement(base_ui_components_atoms_spinner_1.default, { color: type === "primary" ? "white" : "primary", size: "20px" })))));
};
exports.default = Button;
exports.buttonStyle = (0, styled_components_1.css) `
  ${base_ui_components_atoms__atoms_1.common};
  box-sizing: border-box;
  text-decoration: none;
  background: none;
  border: none;
  display: flex;
  align-items: ${({ alignItems = "center" }) => alignItems};
  justify-content: ${({ justifyContent = "center" }) => justifyContent};
  cursor: pointer;
  position: relative;
  font-family: "Poppins" !important;

  * {
    position: relative;
    z-index: 1;
  }

  ${({ styledType, theme, width = "auto", height = "45px", padding = "12px 30px", fontSize = "M", background = "primary", color = "white", hoverColor = "white", hoverBackground = "primaryDarker", loading, }) => {
    var _a, _b, _c, _d;
    return styledType === "primary" &&
        (0, styled_components_1.css) `
      position: relative;
      background: ${theme.color[background]};
      font-size: ${theme.font[fontSize]};
      font-weight: ${theme.font.normal};
      width: ${width};
      height: ${height};
      padding: ${padding};
      color: ${(_a = theme.color[color]) !== null && _a !== void 0 ? _a : color};
      border-radius: ${theme.variable.borderRadius};
      transition: background 0.3s;

      svg {
        width: ${theme.font[fontSize]};
        height: ${theme.font[fontSize]};
        margin-right: 10px;
        color: ${(_b = theme.color[color]) !== null && _b !== void 0 ? _b : color};
      }

      ${!loading &&
            (0, styled_components_1.css) `
        &:hover {
          background: ${(_c = theme.color[hoverBackground]) !== null && _c !== void 0 ? _c : hoverBackground};
          color: ${(_d = theme.color[hoverColor]) !== null && _d !== void 0 ? _d : hoverColor};
        }
      `}
    `;
}}

  ${({ styledType, theme, background = "background", width = "auto", height = "45px", padding = "12px 30px", fontSize = "M", color = "second", hoverBackground = "backgroundDarker", loading, }) => {
    var _a, _b;
    return styledType === "secondary" &&
        (0, styled_components_1.css) `
      background: ${theme.color[background]};
      font-size: ${theme.font[fontSize]};
      font-weight: ${theme.font.normal};
      width: ${width};
      height: ${height};
      padding: ${padding};
      color: ${(_a = theme.color[color]) !== null && _a !== void 0 ? _a : color};
      border-radius: ${theme.variable.borderRadius};
      transition: background 0.3s;

      svg {
        width: ${theme.font[fontSize]};
        height: ${theme.font[fontSize]};
        margin-right: 10px;
        color: ${(_b = theme.color[color]) !== null && _b !== void 0 ? _b : color};
      }

      ${!loading &&
            (0, styled_components_1.css) `
        &:hover {
          background: ${theme.color[hoverBackground]};
        }
      `}
    `;
}}

  ${({ styledType, theme, color = "second", width = "fit-content", padding = "12px 30px", background, loading, }) => {
    var _a;
    return styledType === "third" &&
        (0, styled_components_1.css) `
      font-size: ${theme.font.M};
      font-weight: ${theme.font.normal};
      color: ${theme.color[color]} !important;
      width: ${width};
      padding: ${padding};
      transition: color 0.3s;

      ${background &&
            (0, styled_components_1.css) `
        background: ${(_a = theme.color[background]) !== null && _a !== void 0 ? _a : background};
      `}

      ${!loading &&
            (0, styled_components_1.css) `
        &:hover {
          color: ${theme.color.primary};
        }
      `};

      svg {
        width: ${theme.font.L};
        height: ${theme.font.L};
        margin-right: 10px;
        color: ${theme.color[color]} !important;
      }
    `;
}}

  ${({ styledType, theme, width = "fit-content", padding = "0px", loading }) => styledType === "fourth" &&
    (0, styled_components_1.css) `
      font-size: ${theme.font.S};
      font-weight: ${theme.font.normal};
      color: ${theme.color.second} !important;
      width: ${width};
      padding: ${padding};
      transition: color 0.3s;

      ${!loading &&
        (0, styled_components_1.css) `
        &:hover {
          color: ${theme.color.primary};
        }
      `};

      svg {
        width: ${theme.font.S};
        height: ${theme.font.S};
        margin-right: ${({ theme }) => theme.font.XS};
        color: ${theme.color.second} !important;
      }
    `}

  ${({ disabled }) => disabled &&
    (0, styled_components_1.css) `
      cursor: not-allowed;
      opacity: 0.5;
    `};

  ${({ loading }) => loading &&
    (0, styled_components_1.css) `
      cursor: not-allowed;
    `};
`;
const StyledButton = styled_components_1.default.button `
  ${exports.buttonStyle}
`;
//# sourceMappingURL=Button.js.map